export function renderBodyWithMarkers(body, markers, onMarkerClick) {
  const bodyMarkers = markers.filter(
    (m) => m.location !== 'sender' && m.location !== 'subject' && m.location !== 'signature'
  );

  if (bodyMarkers.length === 0) return [body];

  let parts = [body];

  bodyMarkers.forEach((marker) => {
    parts = parts.flatMap((part) => {
      if (typeof part !== 'string') return [part];

      const idx = part.indexOf(marker.marker_text);
      if (idx === -1) return [part];

      return [
        part.slice(0, idx),
        <span
          key={marker.id}
          onClick={() => onMarkerClick(marker.location)}
          style={{ cursor: 'default' }}
        >
          {marker.marker_text}
        </span>,
        part.slice(idx + marker.marker_text.length),
      ];
    });
  });

  return parts;
}